export default "__VITE_ASSET__QpJT2QRo__"